<template>
  <div>
    <cookie-badge
      :city="city"
      :firstname="firstname"
      :lastname="lastname"
      :state="state"
      :zip="zip"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import CookieBadge from "App/CookieBadge.vue";
import DateInput from "App/UIComponents/DateInput.vue";

export default {
  name: "CACCookieView",
  components: {
    CookieBadge,
    DateInput
  },
  props: {
    birthday: {
      required: false,
      type: String,
      default: ""
    },
    city: {
      required: true,
      type: String
    },
    firstname: {
      required: true,
      type: String
    },
    lastname: {
      required: true,
      type: String
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    state: {
      required: true,
      type: String
    },
    zip: {
      required: true,
      type: String
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.cookie-info-prompt {
  font-size: 0.8em;
}
.birthday-label {
  margin-right: 25px;
}
</style>
